// FLAGS: none
// The login-page denial message for an authenticated account without the CustomerSuccess role.
import { ShieldX } from "lucide-react";
import { Button } from "@openup/shared/primitives/ui/button";
import { useLogoutMutation } from "@src/queries/auth";

interface NotPermittedProps {
  onSignedOut: () => void;
}

/**
 * Shown on the login page when authentication succeeded but the account
 * lacks the CustomerSuccess role (AC2).
 */
const NotPermitted = ({ onSignedOut }: NotPermittedProps) => {
  const logoutMutation = useLogoutMutation();

  const onSignOut = () => {
    logoutMutation.mutate(undefined, { onSettled: onSignedOut });
  };

  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <ShieldX className="h-10 w-10 text-indigo-800" aria-hidden />
      <p className="text-gray-600" role="alert">
        You&apos;re not permitted to log in to this application. Please contact
        your administrator.
      </p>
      <Button
        variant="ghost"
        size="default"
        onClick={onSignOut}
        disabled={logoutMutation.isPending}
      >
        Sign in with a different account
      </Button>
    </div>
  );
};

export default NotPermitted;
